var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "border-b pt-5 pb-4 flex items-center justify-center sm:justify-between sm:flex-row flex-col flex-wrap",
    },
    [
      _c("div", { staticClass: "mr-3 mb-2 sm:mb-0" }, [
        _c(
          "div",
          { staticClass: "flex items-center text-xl text-gray-900" },
          [
            _vm._t("avatar"),
            _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "flex mb-1" },
                  [
                    _vm.title
                      ? _c(
                          "h2",
                          {
                            staticClass:
                              "font-bold text-lg text-gray-900 sm:truncate mr-4",
                          },
                          [_vm._v(" " + _vm._s(_vm.title) + " ")]
                        )
                      : _vm._e(),
                    _vm._t("status"),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "flex flex-row flex-wrap" },
                  [_vm._t("icons")],
                  2
                ),
                _vm._t("annotation"),
              ],
              2
            ),
          ],
          2
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "actions flex justify-end items-center lg:ml-4 space-x-2 mb-2 sm:mb-0",
        },
        [_vm._t("actions")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }